// Member header card design tokens (Figma: Member Detail pages / component sheet)
export const headerPalette = {
  violet: '#512D6D',
  violetDark: '#45245F',
  violetSoft: '#E5DAEC',
  whisper: '#F5F0F8',
  // Status chip states
  successBg: '#E8F5E9',
  successFg: '#2E7D32',
  warningBg: '#FFF3E0',
  warningFg: '#EF6C00',
  errorBg: '#FFEBEE',
  errorFg: '#D32F2F',
  neutralBg: '#F5F5F5',
  // Text emphasis
  textPrimary: 'rgba(0, 0, 0, 0.87)',
  textSecondary: 'rgba(0, 0, 0, 0.6)',
  textDisabled: 'rgba(0, 0, 0, 0.38)',
  dividerLight: 'rgba(0, 0, 0, 0.08)',
  divider: 'rgba(0, 0, 0, 0.12)',
};
